import { initStages } from "@hz/common/constants";

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import TrialAwareLayout from "@components/layout";

import Dashboard from "@compositions/dashboard";
import ReconnectPage from "@compositions/reconnect";

import { selectInit } from "@state/mondaySlice";

const InitPage = () => {
  const { stage, connections, mapping } = useSelector(selectInit);
  const { hasMapping, entityType } = mapping;

  const { isMondayConnected, isGoogleConnected } = connections;
  const isConnected = isMondayConnected && isGoogleConnected;

  if (stage === initStages.COMPLETE && hasMapping && entityType && isConnected) {
    return (
      <TrialAwareLayout>
        <Dashboard />
      </TrialAwareLayout>
    );
  }

  if (stage === initStages.COMPLETE && isConnected && !hasMapping) {
    return (
      <Navigate
        to="/mappings"
        replace
      />
    );
  }

  if (!isConnected && hasMapping) {
    console.log("reconnect page");
    return (
      <ReconnectPage
        isMondayConnected={connections.isMondayConnected}
        isGoogleConnected={connections.isGoogleConnected}
      />
    );
  }

  // Fallback to normal onboarding
  return (
    <Navigate
      to="/onboarding"
      replace
    />
  );
};

export default InitPage;
